import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import HelpText from '../../components/help/HelpText';

import { adminUser, retailUser, renderErrorWarning, renderErrors } from '../../utilities/Forms.js'
import Audits from '../../components/shared/Audits';
import {request, handleRequestErrors} from '../../helpers/Requests'

class UpdateOrganisation extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    organisationName: "",
    timezone: "",
    device_flow_order: "",
    slot_length: "",

    timezones: [],

    loaded: false,
    timezonesLoaded: false,
    unauthorized: "",
    error: "",
    errors: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      [name]: value,
      success: false
    });
  }

  handleCheckbox(event) {
    let name = event.target.name;
    let value = event.target.checked;

    this.setState({
      [name]: value,
      success: false
    });
  }

  handleSubmit(event) {
    var json = JSON.stringify({
     "organisation": {
       "name": this.state.organisationName,
       "timezone": this.state.timezone,
       "device_flow_order": this.state.device_flow_order,
       "slot_length": this.state.slot_length,
       "anonymous_carenotes": this.state.anonymous_carenotes
     }
    })

    request("PUT", `/v1/a/organisations/0`, json, () => {this.setState({unauthorized: true})})
      .then(data => {
        localStorage.setItem('organisationName', data.name);
        this.setState({ errors: "" })
        sessionStorage.setItem("updateSuccess", "Organisation updated successfully!");
        this.props.updatePopupCallback(Math.random())
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))

    event.preventDefault();
  }

  renderSaveButton() {
    if (adminUser()) {
      return <input type="submit" value="Save" />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  render() {

    const { organisationName, timezone, device_flow_order, slot_length, anonymous_carenotes, timezones, timezonesLoaded, loaded, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false || timezonesLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded && timezonesLoaded ) {
      return (
        <div>
          <form className="settings big-settings top-padding" onSubmit={this.handleSubmit}>
            <div className="row">
              <HelpText page={'organisation'} section={'name'} />

              <p>Organisation Name:</p>{ renderErrors(errors, 'name') }
              <input type="text" name="organisationName" value={organisationName} onChange={this.handleChange} />
            </div>

            <div className="row">
              <HelpText page={'organisation'} section={'timezone'} />

              <label className="column">Timezone:</label>{ renderErrors(errors, 'timezone') }
              <select name="timezone" onChange={this.handleChange} value={timezone}>
                <option value="">Select</option>
                {timezones.map((timezone) => (
                  <option value={timezone} key={timezone}>{timezone}</option>
                ))}
              </select>
            </div>

            <div className="row">
              <HelpText page={'organisation'} section={'device_flow_order'} />

              <label className="column">Device Flow Order:</label>{ renderErrors(errors, 'device_flow_order') }
              <select name="device_flow_order" onChange={this.handleChange} value={device_flow_order}>
                <option value="">Select</option>
                <option value="profiles">Profiles</option>
                <option value="arriving_or_leaving">Arriving or Leaving</option>
              </select>
            </div>

            {retailUser() && (
              <div className="row">
                <div className="block">
                  <label className="column">Slot Length: <HelpText className="inline" page={'organisation'} section={'slot_length'} /></label>{ renderErrors(errors, 'slot_length') }
                </div>
                <input className="short-input" type="text" name="slot_length" value={slot_length} onChange={this.handleChange} /> <div className="inline"> minutes</div>
              </div>
            )}

            {!retailUser() && (
              <div className="row">
                <HelpText className="inline" page={'organisation'} section={'anonymous_carenotes'} />
                <input className="column" type="checkbox" id="anonymous_carenotes" name="anonymous_carenotes" checked={anonymous_carenotes} onChange={this.handleCheckbox} />
                <label className="column checkbox-label" htmlFor="anonymous_carenotes">Anonymous visitor carenotes?</label>{ renderErrors(errors, 'anonymous_carenotes') }
              </div>
            )}

            <div className="row">
              { this.renderSaveButton() }
              { renderErrorWarning(errors) }
            </div>
          </form>

          <Audits klass="Organisation" id={0} />
        </div>
      );
    }
  }

  componentDidMount() {
    request("GET", `/v1/a/organisations/0`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        localStorage.setItem('organisationName', data.name);
        this.setState({
          organisationName: data.name,
          timezone: data.timezone,
          device_flow_order: data.device_flow_order,
          slot_length: data.slot_length,
          anonymous_carenotes: data.anonymous_carenotes,
          loaded: true
        })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))

    request("GET", `/list_of_timezones`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ timezones: data.timezones, timezonesLoaded: true }))
      .catch(error => handleRequestErrors(this, error, { timezonesLoaded: true }))
  }
}


export default UpdateOrganisation;
